import { useRootStore } from './index';
import { RetroDiscountsInput } from 'api';
import { action, observable } from 'mobx';

export class RetroDiscountsStore {
  @observable retroDiscountsInput: RetroDiscountsInput[] = [];
  @action setRetroDiscountsInput = (discounts: RetroDiscountsInput[]) => (this.retroDiscountsInput = discounts);
}

export const useRetroDiscountsStore = (): RetroDiscountsStore => {
  const store = useRootStore();
  if (!store.retroDiscountsStore) throw new Error('Retro discounts store has not been initialized');
  return store.retroDiscountsStore;
};
